import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";
import { utils } from "supabase/content/utils.ts";
import { route } from "./types.ts";


export const getRoutes = defineQuery({
  input: z.object({
    bypassCache: z.boolean().optional()
  }).optional(),
  handler: async ({ db }) => {
    const statusFilter = utils.checkStatusEnv();
    const envs = []
    statusFilter.forEach((e) => {
      if (e == "published") envs.push("production");
      if (e == "draft") envs.push("staging");
    })

    const { data, error } = await db
      .from("routes")
      .select("*")
      .in("env", envs)
    if (error) throw error;
    return data as route[];
  },
});
